<script>
import { orderTypes } from "@/store/types/types.js";
import PrintPage from "../PrintPage";
import * as moment from "moment";
export default {
  name: "BagCardModal",
  data() {
    return {
      date: "",
      year: "",
      month: "",
      day: "",
      orderList: [],
      printList: [],
      finalPrintList: [],
      checkAll: false
    };
  },
  components: {
    PrintPage
  },
  computed: {
    orderAllList: {
      get() {
        return this.$store.getters[orderTypes.getters.getTotalOrderList].filter(
          order => {
            return order.delivered_at === this.date;
          }
        );
      }
    }
  },
  methods: {
    decorateOrderId(id) {
      let newId = String(id);
      let originLength = newId.length;
      if (originLength < 12) {
        for (let index = 0; index < 12 - originLength; index++) {
          newId = "0" + newId;
        }
        return newId;
      }
      return id;
    },
    printBagModal() {
      this.$htmlToPaper("printBagCard");
    },
    clickOrderPrint(index) {
      this.printList.push(this.orderList[index]);
      this.printList = JSON.parse(JSON.stringify(this.orderAllList))
        .map(order => {
          order.id = this.decorateOrderId(order.id);
          return order;
        })
        .filter(order => order.print);
      this.checkAll = this.orderList.every(order => {
        return order.print;
      });
    },
    goToPreDay() {
      this.printList = [];
      this.checkAll = false;
      let now = moment().unix();
      let pageDate = moment(this.date).unix();
      if (pageDate <= now) return;
      this.date = moment(this.date)
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      this.year = this.date.split("-")[0];
      this.month = this.date.split("-")[1];
      this.day = this.date.split("-")[2];
      this.$store.dispatch(
        orderTypes.actions.QUERY_TODAY_ORDER_LIST,
        this.date
      );
    },
    goToNextDay() {
      this.printList = [];
      this.checkAll = false;
      this.date = moment(this.date)
        .add(1, "days")
        .format("YYYY-MM-DD");
      this.year = this.date.split("-")[0];
      this.month = this.date.split("-")[1];
      this.day = this.date.split("-")[2];
      this.$store.dispatch;
      this.$store.dispatch(
        orderTypes.actions.QUERY_TODAY_ORDER_LIST,
        this.date
      );
    },
    checkAllBox() {
      this.orderList = this.orderList.map(order => {
        order.print = this.checkAll;
        return order;
      });
      this.printList = this.orderAllList.map(order => order);
      this.printList = JSON.parse(JSON.stringify(this.orderAllList)).map(
        order => {
          order.id = this.decorateOrderId(order.id);
          return order;
        }
      );
    }
  },
  watch: {
    printList: {
      handler(val) {
        this.printList = val;
      },
      deep: true
    },
    orderAllList: {
      handler(val) {
        this.orderList = val;
      },
      deep: true
    }
  },
  mounted() {
    this.orderList = this.orderAllList.map(order => {
      order.print = false;
      return order;
    });
    this.date = moment().format("YYYY-MM-DD");
    this.year = this.date.split("-")[0];
    this.month = this.date.split("-")[1];
    this.day = this.date.split("-")[2];
  }
};
</script>


<template src="./template.html"></template>
<style lang="scss" src="./style.scss"/>
